import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Typography, CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import { getProcurementDetail } from "../../api/biomassProcurement";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../components/Alert";
import CustomAppBar from "../../components/AppBar";
import ProcurementDetailCard from "../../components/Biochar/ProcurementDetailCard";
import ScheduleInspectionForm from "../../components/Biochar/ScheduleInspectionForm";
import { updateProcurement } from "../../api/biomassProcurement";
import { getUserBasicDetailFromAuth } from "../../utils/common";
import { getAreaManagerVles } from "../../api/userManagement";

const ProcurementScheduleInspection = () => {
  const { role, app_user_id } = getUserBasicDetailFromAuth();
  const { id } = useParams();
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [procurement, setProcurement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [vles, setVLEs] = useState([]);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    vle: role === "VLE" ? app_user_id : "",
    visiting_on: dayjs(),
    comments: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    console.log("e", e);
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const fetchProcurementDetails = async () => {
    try {
      const response = await getProcurementDetail(id);
      console.log("Procurement details:", response);
      setProcurement(response);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching procurement details:", error);
      showAlert("error", "Failed to fetch procurement details");
      setLoading(false);
    }
  };

  const fetchAreaManagerVLEs = async () => {
    try {
      if (role === "VLE") {
        return;
      }
      const response = await getAreaManagerVles(app_user_id);
      const vles = response.data.vles;
      console.log("VLEs:", vles);
      setVLEs(vles || []);
    } catch (error) {
      console.error("Error fetching VLEs:", error);
      showAlert("error", "Failed to fetch VLEs");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!formData.visiting_on) {
      errors.visiting_on = "Visiting date is required";
    }
    if (!formData.comments) {
      errors.comments = "Comments are required";
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    try {
      let request_data = {
        scheduled_inspection_on: dayjs(formData.visiting_on).format(),
        comments: formData.comments || "",
        inspected_by: formData.vle,
      };
      let response = await updateProcurement(id, request_data);
      console.log("Inspection scheduled successfully:", response.data);
      showAlert("success", t("Inspection scheduled successfully"));
      navigate("/procurement-list");
    } catch {
      (error) => {
        console.error("Error scheduling inspection:", error);
        showAlert("error", "Failed to schedule inspection");
      };
    }
  };

  useEffect(() => {
    fetchProcurementDetails();
    fetchAreaManagerVLEs();
  }, []);

  return (
    <>
      <CustomAppBar />
      {loading ? (
        <CircularProgress />
      ) : procurement ? (
        <>
          <ProcurementDetailCard procurement={procurement} />
          <ScheduleInspectionForm
            formData={formData}
            errors={errors}
            onChange={(e) => handleChange(e)}
            onSubmit={handleSubmit}
            vles={vles}
          />
        </>
      ) : (
        <Typography variant="h6">{t("Procurement not found")}</Typography>
      )}
    </>
  );
};

export default ProcurementScheduleInspection;
